/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum StepDataType {
    TEXT = 0,
    DATE = 1,
    FILE = 2,
    BOOLEAN = 3,
}
